import { Component, OnInit } from '@angular/core';
import { VesselCalculationInventoryService } from 'src/app/services/danish-shipping-services/vessel-calculation-inventory.service';

@Component({
  selector: 'app-scenario-category-list',
  templateUrl: './scenario-category-list.component.html',
  styleUrls: ['./scenario-category-list.component.css']
})
export class ScenarioCategoryListComponent implements OnInit {
  scenarioCategories: any[] = [];
  filteredScenarioCategories: any[] = [];
  searchTerm: string = '';

  constructor(private scenarioCategoryService: VesselCalculationInventoryService) { }

  ngOnInit(): void {
    this.loadScenarioCategory();
  }

  loadScenarioCategory(): void {
    this.scenarioCategoryService.getScenarioCategory().subscribe(response => {
      this.scenarioCategories = response; 
      this.filteredScenarioCategories = [...response];

    }, error => {
      console.error('Error fetching Scenario Category:', error);
    });
  }
  filterScenarioCategory(): void {
    const term = this.searchTerm.toLowerCase();
  
    this.filteredScenarioCategories = this.scenarioCategories.filter(category =>
      category.title.toLowerCase().includes(term) ||
      category.scenario?.name?.toLowerCase().includes(term)
    );
  }
  
  
  

}

